import { render } from "./BudgetField.vue?vue&type=template&id=390e6d4f&scoped=true&ts=true"
import script from "./BudgetField.vue?vue&type=script&lang=ts"
export * from "./BudgetField.vue?vue&type=script&lang=ts"

import "./BudgetField.vue?vue&type=style&index=0&id=390e6d4f&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-390e6d4f"]])

export default __exports__